/**
 * FundingGuardBanner — big red warning at the top of a job when the landlord
 * quote is signed but not yet funded. Prevents crews from rolling out for
 * free. Rendered on both worker (JobDetail) and admin (Admin.jsx) job pages.
 *
 * The actual clock-in / en-route API calls also 409 with `code:funding_pending`
 * — the banner is the visual complement.
 */
import { Warning } from "@phosphor-icons/react";

export default function FundingGuardBanner({ job }) {
  const q = job?.landlord_quote;
  if (!q || q.status !== "signed" || q.funded_at) return null;
  const total = ((q.landlord_total_cents || 0) / 100).toFixed(2);
  const signedAt = q.signed_at ? new Date(q.signed_at) : null;
  return (
    <div className="mt-3 rugged-card p-4 bg-orange-50 border-l-4 border-orange-500"
         data-testid="funding-guard-banner">
      <div className="flex items-start gap-3">
        <Warning weight="fill" size={24} className="text-orange-600 shrink-0 mt-0.5"/>
        <div className="min-w-0 flex-1">
          <div className="font-black uppercase tracking-wider text-orange-800 text-sm">
            ⚠️ Funding Pending — Do Not Dispatch
          </div>
          <div className="mt-1 text-sm text-orange-900 font-medium leading-relaxed">
            Landlord signed the ${total} quote{signedAt ? ` on ${signedAt.toLocaleDateString()}` : ""} but AppFolio funds haven't cleared yet.
            Confirm funding before rolling the crew, or click <b>Mark Funded</b> on the quote card below once you see the money.
          </div>
        </div>
      </div>
    </div>
  );
}
